import { render, staticRenderFns } from "./PathwaysList.vue?vue&type=template&id=2457c774&"
import script from "./PathwaysList.vue?vue&type=script&lang=js&"
export * from "./PathwaysList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports